import { Box } from "@mui/material";
import { TEAM_EMOJIS } from "../messages-constants";
import { buildReactionSummary } from "../messages-utils";

type Props = {
  messageId: string;
  reactions: any[];
  reactionPickerForId: string | null;
  onToggleReaction: (messageId: string, emoji: string) => void;
  currentUserId?: string;
  role?: string;
};

const MessageReactions = ({
  messageId,
  reactions,
  reactionPickerForId,
  onToggleReaction,
  currentUserId,
  role,
}: Props) => {
  const reactionSummary = buildReactionSummary(reactions, currentUserId, role);

  return (
    <>
      {reactionSummary.length > 0 && (
        <Box className="message-reactions">
          {reactionSummary.map((reaction) => (
            <button
              key={reaction.emoji}
              type="button"
              className={`message-reaction ${
                reaction.reacted ? "is-active" : ""
              }`}
              onClick={() => onToggleReaction(messageId, reaction.emoji)}
            >
              <span className="message-reaction-emoji">{reaction.emoji}</span>
              <span className="message-reaction-count">{reaction.count}</span>
            </button>
          ))}
        </Box>
      )}
      {reactionPickerForId === messageId && (
        <Box className="message-reaction-picker">
          {TEAM_EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type="button"
              className="message-reaction-emoji-button"
              onClick={() => onToggleReaction(messageId, emoji)}
            >
              {emoji}
            </button>
          ))}
        </Box>
      )}
    </>
  );
};

export default MessageReactions;
